module.exports = __webpack_public_path__ + "media/images/application/pub/image-pub-b3649df7bf1bb9f9ccbc389a86565f34.svg";